import { Box, Tab, Tabs } from '@mui/material';
import React, { useState } from 'react';
import CAppTitle from '../../../../app/components/CAppTitle';
import CTestUiSelects from './components/CTestUiSelects';
import CTestUiTextfields from './components/CTestUiTextfields';
import CTestUiButtons from './components/CTestUiButtons';
import CTestUiAlerts from './components/CTestUiAlerts';
import CTestUiPapers from './components/CTestUiPapers';
import CTestUiDataGrids from './components/CTestUiDataGrids';
import CTestUiComponents from './components/CTestUiComponents';
import CTestUiTypographys from './components/CTestUiTypographys';
import ITestData from './interfaces/ITestData';

const TestUi = () => {
	const [data, setData] = useState<ITestData>({
		tab: 'typography',
		textfield: null,
		select: null,
		selects: null,
	});

	const renderTabContent = () => {
		switch (data.tab) {
			default:
				return '';
			case 'textfield':
				return <CTestUiTextfields data={data} setData={setData} />;
			case 'select':
				return <CTestUiSelects data={data} setData={setData} />;
			case 'button':
				return <CTestUiButtons />;
			case 'alert':
				return <CTestUiAlerts />;
			case 'paper':
				return <CTestUiPapers />;
			case 'datagrid':
				return <CTestUiDataGrids />;
			case 'typography':
				return <CTestUiTypographys />;
			case 'components':
				return <CTestUiComponents />;
		}
	};

	return (
		<Box>
			<CAppTitle title="Test UI" subtitle="Please select component tab" />

			<Tabs
				value={data && data.tab ? data.tab : 'textfield'}
				onChange={(event: React.SyntheticEvent, newValue: string) =>
					setData((prevData) => ({
						...prevData,
						tab: newValue,
					}))
				}
			>
				<Tab value="typography" label="Typography" />
				<Tab value="components" label="Composants" />
				<Tab value="textfield" label="TextField" />
				<Tab value="select" label="Select" />
				<Tab value="autocomplete" label="Autocomplete" />
				<Tab value="paper" label="Paper" />
				<Tab value="alert" label="Alert" />
				<Tab value="button" label="Buttons" />
				<Tab value="datagrid" label="DataGrid" />
			</Tabs>
			{data && data.tab ? renderTabContent() : ''}
		</Box>
	);
};

export default TestUi;
